import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import KeyboardArrowBeforeIcon from '@material-ui/icons/NavigateBefore';
import KeyboardArrowNextIcon from '@material-ui/icons/NavigateNext';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import PrometSelect from '../PrometSelect';
import Ddl from '../../../models/common/Ddl';
import I18n from '../../../blocks/localization';

interface Props {
    page?: number;
    size?: number;
    total?: number;
    dataCount: number;
    onPageChange?: (pageNumber: number) => void;
    onSizeChange?: (resultsPerPage: number) => void;
}

const itemsPerPage: Ddl[] = [
    { id: 10, value: 10, secondaryValue:1.33 },
    { id: 25, value: 25, secondaryValue: 3.32 },
    { id: 50, value: 50, secondaryValue: 6.64 },
    { id: 75, value: 75, secondaryValue: 9.95},
    { id: 100, value: 100, secondaryValue:13.27 }
];

const defaultOptions = {
    maxPages: 5,
    page: 1,
    size: itemsPerPage[0].id,
    total: 0
}

const PrometTableFooter = (props: Props) => {
    const [state, setState] = useState({
        page: props.page || defaultOptions.page,
        size: props.size || itemsPerPage[0].id,
        total: props.total || defaultOptions.total
    });

    useEffect(() => {
        setState({ ...state, total: props.total ?? defaultOptions.total })
    }, [props.total]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setState({ ...state, page: props.page ?? defaultOptions.page })
    }, [props.page]); // eslint-disable-line react-hooks/exhaustive-deps

    function onChange(name: string, value: any) {
        setState({ ...state, [name]: value });
    }

    function onSizeChange(name: string, size: number) {
        if (state.size === size) return;
        onChange('size', size);
        if (!props.onSizeChange) return;
        props.onSizeChange(size);
    }

    function onPageChange(page: number) {
        if (page <= 0 || page > getNumberOfPages() || page === state.page) return;
        onChange('page', page);
        if (!props.onPageChange) return;
        props.onPageChange(page);
    }

    function getNumberOfPages() {
        if (state.size === 0) return 0;
        return Math.ceil(state.total / state.size);
    }

    function getPages() {
        let totalPages = getNumberOfPages()
        let pages = [] as number[];
        if (totalPages === 0) return pages;

        const distance = (defaultOptions.maxPages - 1) / 2;

        let startPage = state.page - distance;
        if (startPage < distance) {
            startPage = 1;
        }
        if (startPage > totalPages - defaultOptions.maxPages + 1) {
            startPage = totalPages - defaultOptions.maxPages + 1;
        }

        for (var i = startPage; i < startPage + defaultOptions.maxPages; i++) {
            if (i < 1) continue;
            pages.push(i);
        }
        return pages;
    }

    function getRowFrom(): number {
        if (!state.page || !state.size || !state.total) return 0;
        return (state.page - 1) * state.size + 1;
    }

    function getRowTo(): number {
        const rowTo = getRowFrom() + state.size - 1;
        return rowTo <= state.total ? rowTo : state.total;
    }

    const { total } = props;
    const numbers = getPages();

    return (
        <div className='promet-table-footer'>
            <div className='pagination-wrapper d-flex'>
                <nav>
                    <ul className='pagination'>
                        <li className='page-item page-item-navigation page-item-mobile'>
                            <Link to={{}} className='page-link' aria-label='First' onClick={() => onPageChange(1)}>
                                <FirstPageIcon fontSize='small' />
                            </Link>
                        </li>
                        <li className='page-item page-item-navigation page-item-mobile mx-1'>
                            <Link to={{}} className='page-link' aria-label='Previous' onClick={() => onPageChange(state.page - 1)}>
                                <KeyboardArrowBeforeIcon fontSize='small' />
                            </Link>
                        </li>
                        {
                            numbers && numbers.map((n: number) => (
                                <li className={`page-item ${n === state.page ? 'active' : ''}`} key={n}>
                                    <Link to={{}} className='page-link' onClick={() => onPageChange(n)}> {n.toString()} </Link>
                                </li>
                            ))
                        }
                        <li className='page-item page-item-navigation mx-1'>
                            <Link to={{}} className='page-link' aria-label='Next' onClick={() => onPageChange(state.page + 1)}>
                                <KeyboardArrowNextIcon fontSize='small' />
                            </Link>
                        </li>
                        <li className='page-item page-item-navigation'>
                            <Link to={{}} className='page-link' aria-label='Last' onClick={() => onPageChange(getNumberOfPages())}>
                                <LastPageIcon fontSize='small' />
                            </Link>
                        </li>
                    </ul>
                </nav>
                <div className='form-group d-inline-flex align-items-center promet-table-footer-results-per-page'>
                    <label className='ml-3 mr-2'>{I18n.t('table.itemsPerPage')}</label>
                    <PrometSelect name='itemsPerPage' value={props.size} onChange={onSizeChange} options={itemsPerPage} small={true} isClearable={false} isSearchable={false} />
                </div>
            </div>
            <p className='total-results'>{getRowFrom()} - {getRowTo()} {I18n.t('table.of')} {total}</p>
        </div>
    )
}

export default PrometTableFooter;